<script setup>
// Выбор темы: светлая / тёмная / как в системе. Компактный вариант (compact) — одна кнопка-значок для страниц входа.
import { computed } from "vue";
import { THEMES, themePreference, isDark, setTheme } from "@/services/theme";

const props = defineProps({ compact: { type: Boolean, default: false } });

// В компактном виде кнопка переключает светлую и тёмную по кругу
const next = computed(() => (isDark.value ? "light" : "dark"));
const current = computed(() => THEMES.find((t) => t.value === (isDark.value ? "dark" : "light")));
void props;
</script>

<template>
  <button
    v-if="compact" type="button" class="btn btn-alt-secondary theme-compact" :title="isDark ? 'Включить светлую тему' : 'Включить тёмную тему'"
    :aria-label="isDark ? 'Включить светлую тему' : 'Включить тёмную тему'" data-testid="theme-compact" @click="setTheme(next)"
  >
    <i class="fa" :class="isDark ? 'fa-sun' : 'fa-moon'"></i><span class="visually-hidden">{{ current.label }}</span>
  </button>

  <div v-else class="px-3 py-2" data-testid="theme-toggle">
    <div class="fs-sm fw-medium mb-2">Тема</div>
    <div class="theme-segment" role="radiogroup" aria-label="Тема оформления">
      <button
        v-for="t in THEMES" :key="t.value" type="button" role="radio" :aria-checked="themePreference === t.value"
        :class="{ 'is-active': themePreference === t.value }" :title="t.label" :aria-label="t.label" :data-theme="t.value" @click.stop="setTheme(t.value)"
      >
        <i class="fa" :class="t.icon"></i>
      </button>
    </div>
  </div>
</template>

<style scoped>
.theme-segment { display: grid; grid-template-columns: repeat(3, 1fr); gap: 0.25rem; padding: 0.25rem; border-radius: 0.6rem; background: var(--app-surface-3); }
.theme-segment button { padding: 0.4rem 0; border: 0; border-radius: 0.45rem; background: transparent; color: var(--app-muted); transition: all 0.15s; }
.theme-segment button:hover { color: var(--app-ink); }
.theme-segment button.is-active { background: var(--app-surface); color: var(--app-accent); box-shadow: 0 1px 4px rgba(0, 0, 0, 0.2); }
.theme-compact { width: 2.5rem; height: 2.5rem; padding: 0; display: inline-grid; place-items: center; border-radius: 50%; }
</style>
